import axios from "axios";
import { useAppContext } from "../../context/AuthContext";
import Endpoints from "../../utils/Endpoints";
import { axiosConfig } from "../../utils/Utils";

interface UserControllerType {
  axiosLogout: Function;
  axiosGetUser: Function;
  axiosGetUserById: Function;
  axiosEditUser: Function;
  axiosUpdateUser: Function;
  axiosGetReviewerList: Function;
  axiosGetUsers: Function;
  axiosSaveReviewer: Function;
  axiosLoginAs: Function;
  axiosGetGroups: Function;
  axiosGetAssociateEditorList: Function;
  axiosUpdateExpertise: Function;
  axiosUpdateUserSeniority: Function;
  axiosPostUpdateGroup: Function;
}

export function UserController(): UserControllerType {
  const { authData } = useAppContext();

  const axiosLogout = () => {
    return axios.post(Endpoints.LOGOUT, {}, axiosConfig(authData!.token));
  };

  const axiosGetUser = (token?: string) => {
    return axios.get(Endpoints.USER, axiosConfig(token ? token : authData!.token));
  };

  const axiosGetUserById = (id: string) => {
    return axios.get(`${Endpoints.USER}/${id}`, axiosConfig(authData!.token));
  };

  const axiosEditUser = (userChange: any) => {
    return axios.post(`${Endpoints.USER}/save`, userChange, axiosConfig(authData!.token));
  };

  const axiosUpdateUser = (id: any, userUpdate: any) => {
    return axios.post(`${Endpoints.USER}/update/${id}`, userUpdate, axiosConfig(authData!.token));
  };

  const axiosGetReviewerList = () => {
    return axios.get(Endpoints.USER + "/reviewer-list", axiosConfig(authData!.token));
  };

  const axiosGetAssociateEditorList = () => {
    return axios.get(Endpoints.USER + "/associate-editor-list", axiosConfig(authData!.token));
  };

  const axiosGetGroups = () => {
    return axios.get(Endpoints.USER + "/groups", axiosConfig(authData!.token));
  };

  const axiosGetUsers = () => {
    return axios.get(Endpoints.USER + "/all", axiosConfig(authData!.token));
  };

  const axiosSaveReviewer = (reviewer: any) => {
    return axios.post(`${Endpoints.USER}/saveReviewer`, reviewer, axiosConfig(authData!.token));
  };

  const axiosLoginAs = (id: any) => {
    return axios.post(`${Endpoints.USER}/loginAs/${id}`, {}, axiosConfig(authData!.token));
  };

  const axiosUpdateExpertise = (id: any, expertise: string) => {
    return axios.post(`${Endpoints.USER}/${id}/updateExpertise`, expertise, axiosConfig(authData!.token));
  };

  const axiosPostUpdateGroup = (id: any, groupId: number) => {
    return axios.post(
      `${Endpoints.USER}/update/${id}/change-role`,
      {},
      axiosConfig(authData!.token, { groupId: groupId })
    );
  };

  const axiosUpdateUserSeniority = (id: any, seniority: string) => {
    return axios.post(
      `${Endpoints.USER}/update/${id}/reviewer-seniority`,
      {},
      axiosConfig(authData!.token, { level: seniority })
    );
  };

  return {
    axiosLogout,
    axiosGetUser,
    axiosGetUserById,
    axiosEditUser,
    axiosUpdateUser,
    axiosGetReviewerList,
    axiosGetUsers,
    axiosSaveReviewer,
    axiosLoginAs,
    axiosGetGroups,
    axiosGetAssociateEditorList,
    axiosUpdateExpertise,
    axiosUpdateUserSeniority,
    axiosPostUpdateGroup,
  };
}

export type { UserControllerType };
